import * as types from '../constants'
import * as utils from '../utils'
import get from 'lodash.get'
import isEmpty from 'lodash.isempty'
import supercluster from 'points-cluster'
import { List } from 'immutable'
import { addMapMarkersToCache } from './addMapMarkersToCache'
import { resetCachedMapMarkers } from './resetCachedMapMarkers'
import { fetchProperty as fetchPropertyAPI } from 'services/api'
import { fetchGQL } from 'services/common'
import { geocode, geolocate } from 'services/geolocation'
import * as api from '../services/api'
import isempty from 'lodash.isempty'

export function fetchProperties({ query, offset = 0, isFranchisee = false, cachePropertyMarkers = false }) {
  return async (dispatch, getState) => {
    const {
      properties: { count },
    } = getState()

    if (isFranchisee && count > 0) {
      return
    }

    dispatch(fetchPropertiesLoading())
    try {
      //FIXME start using services/api as a interface to our backend queries
      const json = await fetchGQL(query, utils.getToken())
      const loc = getState().properties.get('loc')
      dispatch(fetchPropertiesSuccess(json, offset, isFranchisee, loc))
      if (cachePropertyMarkers) dispatch(addMapMarkersToCache(json, isFranchisee, loc))
    } catch (err) {
      dispatch(fetchPropertiesError(err))
    }
  }
}

export function fetchProperty(propertyId, user) {
  return async (dispatch, getState) => {
    dispatch({
      type: types.FETCH_PROPERTY_LOADING,
    })
    const properties = get(getState(), ['properties', 'data'])

    // if the user is logged we have to fetch the property anyways,
    // because is the only way we have to track 'property view' on the backend and to get franchisee data
    let property = !utils.isUserLogged(user) && properties && properties.get(propertyId)
    let errors
    if (!property) {
      try {
        const response = await fetchPropertyAPI(propertyId, user && user.token ? user.token : null)
        if (isEmpty(response.errors)) {
          property = response.property
          dispatch({
            type: types.FETCH_PROPERTY_SUCCESS,
          })
          return {
            property,
            errors,
          }
        } else {
          if (response.errors[0] && response.errors[0].message === 'Not found') {
            errors = ['Something went wrong, we aren’t able to find that property']
          } else {
            dispatch({
              type: types.FETCH_PROPERTY_ERROR,
            })
            throw Error(response.errors)
          }
        }
      } catch (error) {
        dispatch({
          type: types.FETCH_PROPERTY_ERROR,
        })
        throw Error(error)
      }
    } else {
      dispatch({
        type: types.FETCH_PROPERTY_SUCCESS,
      })
      return {
        property,
        errors,
      }
    }
  }
}

export function fetchLocation(address, update = true, geocodeKey = 'address') {
  return async (dispatch, getState) => {
    dispatch(fetchPropertiesLoading())
    try {
      const { location, viewPort } = await geocode(address)
      dispatch(fetchLocationSuccess(location, viewPort, address, update))
      dispatch(mapCenterChange(location))
      return location
    } catch (err) {
      dispatch(fetchLocationError(err))
    }
  }
}

export function fetchUserLocation(latLng = null) {
  return async dispatch => {
    try {
      const location = await geolocate()
      const lat = get(location, 'lat', process.env.REACT_APP_DEFAULT_LAT)
      const lng = get(location, 'lng', process.env.REACT_APP_DEFAULT_LNG)
      dispatch(fetchUserLocationSuccess(location))
      if (latLng) {
        dispatch(mapCenterChange({ lat: latLng.lat, lng: latLng.lng }))
        dispatch(fetchListings(utils.getHomepageQuery(latLng.lat, latLng.lng)))
      } else {
        dispatch(mapCenterChange({ lat: lat, lng: lng }))
        dispatch(fetchListings(utils.getHomepageQuery(lat, lng)))
      }
    } catch (err) {
      dispatch(fetchUserLocationError(err))
    }
  }
}

export function fetchPropertyFilters() {
  return async dispatch => {
    try {
      //FIXME start using services/api as a interface to our backend queries
      const json = await fetchGQL(types.property, utils.getToken())
      dispatch(fetchFilterTypesSuccess(json))
    } catch (err) {
      dispatch(fetchFilterTypesError(err))
    }
  }
}

export function fetchListings(query) {
  return async dispatch => {
    dispatch(fetchListingsLoading())
    try {
      //FIXME start using services/api as a interface to our backend queries
      const json = await fetchGQL(query, utils.getToken())
      dispatch(fetchListingsSuccess(json))
    } catch (err) {
      dispatch(fetchListingsError(err))
    }
  }
}

// Franchisee action
export function fetchFranchisee(query) {
  return async dispatch => {
    dispatch(fetchAdCouncilLoading())
    try {
      //FIXME start using services/api as a interface to our backend queries
      const json = await fetchGQL(query, utils.getToken())
      const franchisee = get(json, 'data.franchisee', {})
      dispatch(fetchPropertiesSuccess(json, 0, true, {}))
      dispatch(fetchAdCouncilSuccess(franchisee))
      dispatch(updatePageType('franchisee'))
    } catch (err) {
      dispatch(fetchAdCouncilError(err))
    }
  }
}

//adcouncil
export function fetchAdCouncil(query) {
  return async dispatch => {
    dispatch(fetchAdCouncilLoading())
    try {
      //FIXME start using services/api as a interface to our backend queries
      const json = await fetchGQL(query, utils.getToken())
      const adCouncil = get(json, 'data.adCouncil', {})
      dispatch(updatePageType('adcouncil'))
      dispatch(fetchAdCouncilSuccess(adCouncil))
      const location = get(adCouncil, 'location', null)
      if (location) {
        return dispatch(fetchLocation(location, true, 'address'))
      }
    } catch (err) {
      dispatch(fetchAdCouncilError(err))
    }
  }
}

//FETCH SUBDOMAIN
export function fetchSubDomain(callback) {
  const subdomain = window.location.hostname.split('.')[0]
  return async dispatch => {
    dispatch(fetchSubdomainLoading())
    try {
      //FIXME start using services/api as a interface to our backend queries
      const response = await fetch(`${process.env.REACT_APP_API_URL.replace('graphql', 'subdomains')}?subdomain=${subdomain}`)
      const json = await response.json()

      dispatch(fetchSubdomainSuccess(json))
      utils.isFunction(callback) && callback(json)
    } catch (err) {
      dispatch(fetchSubdomainError(err))
      utils.isFunction(callback) && callback(null)
    }
  }
}

// Zillow
export function fetchZillow(property) {
  return async dispatch => {
    let error = null
    if (property.showZestimate && !property.hasOwnProperty('zestimate')) {
      try {
        const address = encodeURIComponent(property.address)
        const cityStateZip = encodeURIComponent(`${property.city} ${property.state},${property.zip}`)
        const response = await fetch(`${process.env.REACT_APP_API_URL.replace('graphql', 'zillow/search')}?address=${address}&citystatezip=${cityStateZip}`)
        const responseText = await response.text()
        const domParser = new DOMParser()
        const dom = domParser.parseFromString(responseText, 'application/xml')
        const node = document.evaluate('//zestimate/amount', dom).iterateNext()
        node && (property.zestimate = node.textContent)
      } catch (err) {
        error = err
        dispatch(fetchZillowError(err))
      }
    }
    return {
      property,
      error,
    }
  }
}

// FIXME: WTF does 'bool' mean?
export function updateFilters(bounds, filters, bool = true) {
  return async (dispatch, getState) => {
    dispatch(updateFiltersSuccess(filters))
    dispatch(fetchPropertiesLoading())
    dispatch(resetCachedMapMarkers())

    const filterObj = {
      priceMin: filters.priceMinimum,
      priceMax: filters.priceMaximum,
      areaMin: filters.areaMinimum,
      areaMax: filters.areaMaximum,
      homeTypes: filters.homeTypesSelected,
      types: filters.propertyTypesSelected,
    }
    if (filters.numberOfBedrooms) {
      filterObj['beds'] = filters.numberOfBedrooms
    }
    if (filters.numberOfBathrooms) {
      filterObj['baths'] = filters.numberOfBathrooms
    }
    const queryType = get(getState().subdomain.data.record_type, '')
    const frID = get(getState(), 'franchisee.data.id', null)

    try {
      // FIXME [WSWA-1098] This temporary-fix creates a safe bounds to run bounded-search even when bounds haven't been set.
      // This updateFilters action-creator shouln't be responsible to fill this data here, also shoudn't receive the bounds via args.
      // But considering this updateFilters its being called all over the app (on many componentDidMounts) its safest way to put this hack for now
      const safeBounds = isEmpty(bounds) ? utils.createSafeBounds({ viewPort: getState().properties.viewPort, loc: getState().properties.loc }) : bounds

      const geoRect = {
        w: get(safeBounds, 'sw.lng', parseFloat(process.env.REACT_APP_DEFAULT_LNG)),
        e: get(safeBounds, 'ne.lng', parseFloat(process.env.REACT_APP_DEFAULT_LNG)),
        n: get(safeBounds, 'ne.lat', parseFloat(process.env.REACT_APP_DEFAULT_LAT)),
        s: get(safeBounds, 'sw.lat', parseFloat(process.env.REACT_APP_DEFAULT_LAT)),
      }

      if (bool) {
        const query = utils.getBoundedQuery(geoRect, filterObj, queryType, frID)
        return dispatch(fetchProperties({ query: query }))
      }
    } catch (error) {
      console.error(error)
    }
  }
}

export function fetchPropertiesPage(currentOffset) {
  return fetchPropertiesUsingReduxState({ currentOffset, fetchSize: parseInt(process.env.REACT_APP_FETCH_SIZE, 10) })
}

export function fetchPropertiesFromRect(geoRect) {
  return fetchPropertiesUsingReduxState({ geoRect })
}

/**
 * This is not the best idea, but it's a utility method that fetches properties based on what on the global state has (bounds, filters, ..),
 * with the ability to override some of them
 */
function fetchPropertiesUsingReduxState({ geoRect, currentOffset = 0, fetchSize = 0 }) {
  return async (dispatch, getState) => {
    const queryType = getState().subdomain.data.record_type
    const isFranchisee = queryType === 'Franchisee'

    if (isFranchisee) {
      return
    }

    const offset = currentOffset + fetchSize
    const priceMin = getState().filters.get('priceMinimum')
    const priceMax = getState().filters.get('priceMaximum')
    const beds = getState().filters.get('numberOfBedrooms')
    const baths = getState().filters.get('numberOfBathrooms')
    const areaMin = getState().filters.get('areaMinimum')
    const areaMax = getState().filters.get('areaMaximum')
    const homeTypes = getState().filters.get('homeTypesSelected')
    const types = getState().filters.get('propertyTypesSelected')
    const frID = getState().franchisee ? getState().franchisee.data.id : null

    if (!geoRect) {
      const bounds = getState().map.get('bounds')
      geoRect = {
        w: bounds.getIn(['sw', 'lng']),
        e: bounds.getIn(['ne', 'lng']),
        n: bounds.getIn(['ne', 'lat']),
        s: bounds.getIn(['sw', 'lat']),
      }
    }

    const query = utils.getBoundedQuery(
      geoRect,
      {
        priceMin,
        priceMax,
        beds,
        baths,
        areaMin,
        areaMax,
        homeTypes,
        types,
      },
      queryType,
      frID,
      offset
    )

    dispatch(fetchProperties({ query, offset, isFranchisee }))
  }
}

export function showFlashMessage(err, msg) {
  return async dispatch => {
    if (msg) {
      setTimeout(() => {
        if (typeof dispatch === 'object') {
          dispatch.hideFlashMessage()
        } else {
          dispatch(hideFlashMessage())
        }
      }, 5000)
    }

    dispatch({
      type: types.SHOW_FLASH_MESSAGE,
      msg: msg || utils.getErrorMsg(err),
      isError: err,
    })
  }
}

export function hideFlashMessage() {
  return {
    type: types.HIDE_FLASH_MESSAGE,
  }
}

export function showFlashMessageOnUnexpectedError(
  unexpectedError,
  msg = 'There has been an unexpected error. Please try again. If the error persists, please contact help@dealvestors.com'
) {
  return async dispatch => {
    if (unexpectedError && process.env.NODE_ENV === 'development') {
      console.error(unexpectedError)
    }

    dispatch(showFlashMessage(unexpectedError, msg))
  }
}

export function getClusters(properties, bounds, zoom, minZoom = 3, maxZoom = 18, radius = 90) {
  const cl = supercluster(properties, {
    minZoom, // min zoom to generate clusters on
    maxZoom, // max zoom level to cluster the points on
    radius, // cluster radius in pixels
  })
  const clArr = cl({ bounds, zoom })
  return {
    type: types.GET_CLUSTERS,
    clusters: List(clArr),
  }
}

export function updateSimilarProperties(sProperties) {
  const properties = sProperties.map(el => [el.id, { ...el, lng: el.lon }])
  return {
    type: types.UPDATE_SIMILAR_PROPERTIES,
    data: properties,
  }
}

export function handleSorting(by = 'distance', order = 'asc') {
  return dispatch => {
    dispatch({
      type: types.SORTING,
      sortBy: by,
      sortOrder: order,
    })
    return Promise.resolve()
  }
}

export function authenticate({ email, password }) {
  return async dispatch => {
    dispatch(isLoadingStatus(true))
    let response
    try {
      response = await api.authenticate({ email, password })
      if (isempty(response.errors)) {
        if (response.token) {
          utils.setToken(response.token)
        }
        dispatch(fetchAuthenticateSuccess(response))
      } else {
        dispatch(fetchAuthenticateError(response.errors))
      }
      return response
    } catch (err) {
      dispatch(fetchAuthenticateError(err))
    }
    return response
  }
}

function fetchAuthenticateSuccess(response) {
  return {
    type: types.FETCH_LOCAL_SIGNIN_SUCCESS,
    payload: response,
  }
}

export function isLoadingStatus(status) {
  return {
    type: types.IS_LOADING_STATUS,
    isLoading: status,
  }
}

export function isLoadingUserInfo(status) {
  return {
    type: types.IS_LOADING_USER_INFO,
    isLoadingUserInfo: status,
  }
}

function fetchAuthenticateError(error) {
  return {
    type: types.FETCH_LOCAL_SIGNIN_ERROR,
    error: error,
  }
}

export function userInfo(token) {
  return async dispatch => {
    dispatch(isLoadingUserInfo(true))
    try {
      const response = await api.userInfo(token)
      if (isempty(response.errors)) {
        dispatch(fetchUserInfoSuccess(response))
      } else {
        dispatch(fetchUserInfoError(response.errors))
      }
      return response
    } catch (err) {
      dispatch(fetchUserInfoError(err))
      throw err
    }
  }
}

function fetchUserInfoError(error) {
  return {
    type: types.FETCH_USER_INFO_ERROR,
    error: error,
  }
}

function fetchUserInfoSuccess(response) {
  return {
    type: types.FETCH_USER_INFO_SUCCESS,
    payload: response,
  }
}

export function socialAuthenticate({ OAuthProvider, socialAuthToken }) {
  return async dispatch => {
    dispatch(isLoadingStatus(true))
    try {
      let authRequest = {}
      authRequest[OAuthProvider === types.OAUTH_PROVIDERS.FACEBOOK ? 'facebookToken' : 'googleToken'] = socialAuthToken

      const response = await api.authenticate(authRequest)

      if (isempty(response.errors)) {
        // setting token to localStorage
        if (response.token) {
          utils.setToken(response.token)
          utils.trackEvent({ category: 'Login', action: OAuthProvider.toLowerCase() + ' login' })
        }
        dispatch(socialAuthenticateSuccess({ ...response, OAuthProvider, socialAuthToken }))
      } else {
        dispatch(socialAuthenticateError(response.errors))
      }

      return response
    } catch (err) {
      dispatch(socialAuthenticateError(err))
      throw err
    }
  }
}

export function addPropertyToFavorites(propertyId, user) {
  return async dispatch => {
    dispatch(isLoadingStatus(true))
    try {
      const response = await api.addPropertyToFavorites(propertyId, user.token)

      if (!isempty(response.errors)) dispatch(addPropertyToFavoritesError(response.errors))
      else {
        dispatch(addPropertyToFavoritesSuccess({ propertyId }))
      }

      return response
    } catch (err) {
      dispatch(addPropertyToFavoritesError(err))
      throw err
    }
  }
}

function socialAuthenticateSuccess(response) {
  return {
    type: types.FETCH_SOCIAL_SIGNIN_SUCCESS,
    payload: response,
  }
}

function socialAuthenticateError(error) {
  return {
    type: types.FETCH_SOCIAL_SIGNIN_ERROR,
    error: error,
  }
}

function isUserDataUpdateStart() {
  return {
    type: types.UPDATE_USER_START,
  }
}

export function updateUser(user, token) {
  return async dispatch => {
    dispatch(isUserDataUpdateStart())
    try {
      const response = await api.updateUser(user, token)

      if (isempty(response.errors)) {
        dispatch(updateUserSuccess({ user }))
      } else {
        dispatch(updateUserError(response.errors))
      }

      return response
    } catch (err) {
      dispatch(updateUserError(err))
      throw err
    }
  }
}

function addPropertyToFavoritesSuccess(propertyId) {
  return {
    type: types.ADD_PROPERTIES_FAVORITES_SUCCESS,
    propertyId: propertyId.propertyId,
  }
}

function addPropertyToFavoritesError(error) {
  return {
    type: types.ADD_PROPERTIES_FAVORITES__ERROR,
    error: error,
  }
}

// ACTION CREATOR
export function removePropertyFromFavorites(propertyId, user) {
  return async dispatch => {
    dispatch(isLoadingStatus(true))
    try {
      const response = await api.removePropertyFromFavorites(propertyId, user.token)

      if (!isempty(response.errors)) dispatch(removePropertyFromFavoritesError(response.errors))
      else {
        dispatch(removePropertyFromFavoritesSuccess({ propertyId }))
      }

      return response
    } catch (err) {
      dispatch(removePropertyFromFavoritesError(err))
      throw err
    }
  }
}

function updateUserSuccess(response) {
  return {
    type: types.UPDATE_USER_SUCCESS,
    payload: response,
  }
}

function updateUserError(error) {
  return {
    type: types.UPDATE_USER_ERROR,
    error: error,
  }
}

function removePropertyFromFavoritesSuccess(propertyId) {
  return {
    type: types.REMOVE_PROPERTIES_FAVORITES_SUCCESS,
    propertyId: propertyId.propertyId,
  }
}

function removePropertyFromFavoritesError(error) {
  return {
    type: types.REMOVE_PROPERTIES_FAVORITES_ERROR,
    error: error,
  }
}

export function updateUserAvatar(avatar, token) {
  return async dispatch => {
    dispatch(isUserDataUpdateStart())
    try {
      const response = await api.updateUserAvatar(avatar, token)

      if (isempty(response.errors)) {
        dispatch(updateUserAvatarSuccess(response))
      } else {
        throw Error(response.errors)
      }

      return response
    } catch (err) {
      dispatch(updateUserError(err))
      throw err
    }
  }
}

export function updateUserAvatarSuccess(response) {
  return {
    type: types.UPDATE_USER_AVATAR_SUCCESS,
    payload: response,
  }
}

export function createUser(user, { OAuthProvider, socialAuthToken } = {}) {
  return async dispatch => {
    dispatch(isLoadingStatus(true))
    let response
    try {
      let authRequest = {}
      if (OAuthProvider === types.OAUTH_PROVIDERS.FACEBOOK || OAuthProvider === types.OAUTH_PROVIDERS.GOOGLE) {
        authRequest[OAuthProvider === types.OAUTH_PROVIDERS.FACEBOOK ? 'facebookToken' : 'googleToken'] = socialAuthToken
      }

      response = await api.createUser(user, authRequest)

      if (isempty(response.errors)) {
        if (response.token) {
          utils.setToken(response.token)
        }
        dispatch(createNewUserSuccess(response))
      } else {
        dispatch(createNewUserError(response.errors))
      }
    } catch (err) {
      dispatch(createNewUserError(err))
      throw err
    }
    return response
  }
}

function createNewUserSuccess(response) {
  return {
    type: types.CREATE_NEW_USER_SUCCESS,
    payload: response,
  }
}

function createNewUserError(error) {
  return {
    type: types.CREATE_NEW_USER_ERROR,
    error: error,
  }
}

export function updateUserSettings(user, token) {
  return async dispatch => {
    dispatch(isUserDataUpdateStart())
    try {
      const response = await api.updateUser(user, token)

      if (isempty(response.errors)) {
        dispatch(updateUserSettingsSuccess({ user }))
      } else {
        dispatch(updateUserSettingsError(response.errors))
      }

      return response
    } catch (err) {
      dispatch(updateUserSettingsError(err))
      throw err
    }
  }
}

function updateUserSettingsSuccess(response) {
  return {
    type: types.UPDATE_USER_SETTINGS_SUCCESS,
    payload: response,
  }
}

function updateUserSettingsError(error) {
  return {
    type: types.UPDATE_USER_SETTINGS_ERROR,
    error: error,
  }
}

export function signOut() {
  return async dispatch => {
    dispatch(isLoadingStatus(true))

    utils.removeToken()

    dispatch(signOutSuccess({}))
  }
}

function signOutSuccess() {
  return {
    type: types.SIGN_OUT_SUCCESS,
  }
}
export function mapMarkerHover(id) {
  return {
    type: types.MAP_MARKER_HOVER,
    id,
  }
}

export function mapClusterHover(cluster) {
  return {
    type: types.MAP_CLUSTER_HOVER,
    cluster,
  }
}

export function paginateFromMap(data, offset) {
  return {
    type: types.PAGINATE_FROM_MAP,
    data,
    offset,
  }
}

export function changeMap(zoom, bounds) {
  return {
    type: types.CHANGE_MAP,
    zoom,
    bounds,
  }
}

export function mapCenterChange(center) {
  return {
    type: types.MAP_CENTER_CHANGE,
    loc: center,
  }
}
export function toggleFilters(isForceClose = false) {
  return {
    type: types.TOGGLE_FILTERS,
    isForceClose: isForceClose,
  }
}

export function fetchPropertiesSuccess(json, offset, isFranchisee, loc) {
  const properties = utils.convertPropertiesJSONToRecord(json, isFranchisee, loc)
  const count = get(json, 'data.propertyCount', properties.length)
  return {
    type: types.FETCH_PROPERTIES_SUCCESS,
    data: properties,
    count,
    offset,
  }
}

function fetchPropertiesError(error) {
  return {
    type: types.FETCH_PROPERTIES_ERROR,
    error,
  }
}

function fetchPropertiesLoading() {
  return {
    type: types.FETCH_PROPERTIES_LOADING,
  }
}

function fetchUserLocationSuccess(loc) {
  return {
    type: types.FETCH_USER_LOCATION,
    loc,
  }
}

function fetchUserLocationError(error) {
  return {
    type: types.FETCH_USER_LOCATION_ERROR,
    error,
  }
}

function fetchLocationSuccess(location, viewport, address, update) {
  const loc = update ? location : {}
  const viewPort = update ? viewport : {}
  return {
    type: types.FETCH_LOCATION_SUCCESS,
    loc,
    viewPort,
    address: update ? address : '',
  }
}

function fetchLocationError(error) {
  return {
    type: types.FETCH_LOCATION_ERROR,
    error,
  }
}

export function fetchListingsSuccess(json) {
  const pr = get(json, 'data.properties', [])
  const properties = pr.map(el => [el.id, { ...el, lng: el.lon }])
  const count = get(json, 'data.propertyCount', properties.length)

  return {
    type: types.FETCH_LISTINGS_SUCCESS,
    data: properties,
    count,
  }
}

function fetchListingsError(error) {
  return {
    type: types.FETCH_LISTINGS_ERROR,
    error,
  }
}

function fetchListingsLoading() {
  return {
    type: types.FETCH_LISTINGS_LOADING,
  }
}

function fetchFilterTypesSuccess(json) {
  const filterTypesArr = get(json, 'data.propertyFilters', [])
  return {
    type: types.FETCH_FILTERTYPES_SUCCESS,
    filterTypes: filterTypesArr,
  }
}
function fetchFilterTypesError(error) {
  return {
    type: types.FETCH_FILTERTYPES_ERROR,
    error,
  }
}

function updateFiltersSuccess(filters) {
  return {
    type: types.UPDATE_FILTERS,
    filters,
  }
}

function updatePageType(pageType) {
  return {
    type: types.UPDATE_PAGE_TYPE,
    pageType,
  }
}

function fetchAdCouncilSuccess(adCouncil) {
  return {
    type: types.FETCH_ADCOUNCIL_SUCCESS,
    data: adCouncil,
  }
}

function fetchAdCouncilError(error) {
  return {
    type: types.FETCH_ADCOUNCIL_ERROR,
    error,
  }
}

function fetchAdCouncilLoading() {
  return {
    type: types.FETCH_ADCOUNCIL_LOADING,
  }
}

function fetchSubdomainSuccess(json) {
  return {
    type: types.FETCH_SUBDOMAIN_SUCCESS,
    data: json,
  }
}

function fetchSubdomainError(error) {
  return {
    type: types.FETCH_SUBDOMAIN_ERROR,
    error,
  }
}

function fetchSubdomainLoading() {
  return {
    type: types.FETCH_SUBDOMAIN_LOADING,
  }
}

function fetchZillowError(error) {
  return {
    type: types.FETCH_ZILLOW_ERROR,
    error,
  }
}
export function userStatusUpdate(status) {
  return {
    type: types.UPDATE_USER_STATUS,
    status,
  }
}

// ACTION CREATOR
export function createSusbcription(token, userToken) {
  return async dispatch => {
    try {
      const response = await api.createSubscription(token, userToken)
      return response
    } catch (err) {
      throw err
    }
  }
}

export function cancelSubscription(token) {
  return async dispatch => {
    try {
      const response = await api.cancelSubscription(token)
      return response
    } catch (err) {
      throw err
    }
  }
}

export function flagProperty(data) {
  return async dispatch => {
    try {
      const response = await api.flagProperty(data)
      dispatch(removePropertyFromList(data.from, data.id))
      return response
    } catch (err) {
      throw err
    }
  }
}

export function removePropertyFromList(from, id) {
  return {
    type: from ? types.FLAG_PROPERTY_LISTING : types.FLAG_PROPERTY,
    id: id,
  }
}

export function contactUs(req) {
  return async () => {
    try {
      const response = await api.contactUs(req)
      return response
    } catch (err) {
      throw err
    }
  }
}

export function showSignInModal(openSignInModal) {
  return async dispatch => {
    try {
      dispatch({ type: types.SHOW_SIGNIN_MODAL, showSignIn: openSignInModal })
    } catch (err) {
      throw err
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js